<template>
<div>
  <vb-form-row item-name="ご職業" :required="true">
    <template #title>
      <v-tooltip
        v-model="openHint.job"
        :open-on-hover="false"
        :open-on-click="false"
        top
        color="transparent"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            @click="openHint.job = !openHint.job"
            color="grey lighten-1"
          >
            mdi-help-circle
          </v-icon>
        </template>
        <v-card v-if="openHint.job" v-click-outside="openHint.job? onClickToolTipJobOutside : null" flat
                outlined>
          <v-card-title class="pa-3 pb-1 text-subtitle-2">ご職業について</v-card-title>
          <v-card-text class="pa-3 pt-0">古物営業法に基づき、ご職業をお知らせいただく必要がございます。</v-card-text>
        </v-card>
      </v-tooltip>
    </template>
    <template #input>
      <v-sheet width="100%" :max-width="$vuetify.breakpoint.mdAndUp? 240: null">
        <validation-provider v-slot="{ errors, invalid }" name="ご職業" rules="required|job_code">
          <v-select
            v-model="jobSelected"
            :value="formItemsGetter.jobCode"
            @input="formItemsSetter({name:'jobCode', value: jobSelected.code}); formItemsSetter({name:'jobLabel', value: jobSelected.label})"
            @blur="blurBgColorChange($event, errors[0])"
            @focus="focusBgColorChange($event, errors[0])"
            :items="jobs"
            item-text="label"
            item-value="code"
            :error-messages="errors"
            required
            outlined
            dense
            height="44px"
            return-object
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            hide-details="auto"
            solo
            flat
          >
            <template #label><span class="text-body-2">ご職業</span></template>
          </v-select>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
export default {
  name: "vb-job",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      jobs: [],
      jobSelected: null,
      openHint: {
        job: false,
      }
    }
  },
  created() {
    this.fetchJobs();

    // initialize `jobSelected`
    this.jobSelected = {
      'code': this.formItemsGetter.jobCode,
      'label': this.formItemsGetter.jobLabel,
    };
  },
  methods: {
    fetchJobs() {
      axios.get('/api/ajax/job').then(response => {
        this.jobs = response.data;
      });
    },
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    onClickToolTipJobOutside() {
      this.openHint.job = false;
    },
  }
}
</script>

<style scoped>

</style>